module.exports = "/_next/static/images/24e2c700d34db44c3b7343eb93fa534d-hero-xs.jpg";